import type { Filters } from 'www/vue_components/common/TheFilters/lpu/stores/useFiltersStore.types'

export const DEFAULT_DOCTOR_SPECIALITY: NonNullable<Filters['doctorSpeciality']> = {
  id: 0,
  name: 'Любая',
  translit: 'default-item',
}
